// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"29ca7ad5","213":"48eadd7a"}[chunkId] + ".chunk.js";
};